// extracted by css-extract-rspack-plugin
export default {"moveInMonthContainer":"moveInMonth-module__moveInMonthContainer"};